import { CollectionPaymentTypes, TransactionPaymentType, TransactionStatus } from "@gtpl/shared-models/common-models"

export class CollectionsReq{
    bankCharges : number;
    buyerId : number;
    bankId : number;
    buyerShortPayment : number;
    // dueAmt : number;
    dueDate : Date|string;
    eta : Date|string;
    etd : Date|string;
    invAmt : number;
    invNum : string;
    paymentTermsId : number;
    poNum : string;
    recievedAmt : number;
    soId : number;
    recievedDate : Date|string;
    transactionStatus : TransactionStatus
    transactionType : TransactionPaymentType
    remarks : string;
    createdUser : string;
    payment:CollectionPaymentTypes
 constructor(
    bankCharges : number,
    buyerId : number,
    bankId : number,
    buyerShortPayment : number,
    // dueAmt : number,
    dueDate : Date|string,
    eta : Date|string,
    etd : Date |string,
    invAmt : number,
    invNum : string,
    paymentTermsId : number,
    poNum : string,
    recievedAmt : number,
    soId : number,
    recievedDate : Date |string,
    transactionStatus : TransactionStatus,
    transactionType : TransactionPaymentType,
    remarks : string,
    createdUser : string,
    payment:CollectionPaymentTypes

 ){
    this.bankCharges = bankCharges
    this.bankId = bankId
    this.buyerId = buyerId
    this.buyerShortPayment = buyerShortPayment
    this.createdUser = createdUser
// this.dueAmt = dueAmt
this.dueDate=dueDate
this.eta=eta
this.etd=etd
this.invAmt =  invAmt
this.invNum = invNum
this.paymentTermsId = paymentTermsId
this.poNum = poNum
this.recievedAmt = recievedAmt
this.soId = soId
this.recievedDate =recievedDate
this.transactionStatus = transactionStatus
this.transactionType =transactionType
this.remarks =remarks
this.payment = payment
 }
}
export class DdbCollectionsReq{
   buyerId : number;
   invAmt : number;
   invNum : string;
   recievedAmt : number;
   soId : number;
   recievedDate : Date|string;
   scrollNo : string;
   scrollDate : Date|string;
   remarks : string;
   createdUser : string;
   payment:CollectionPaymentTypes

constructor(
   buyerId : number,
   invAmt : number,
   invNum : string,
   recievedAmt : number,
   soId : number,
   recievedDate : Date|string,
   scrollNo : string,
   scrollDate : Date|string,
   remarks : string,
   createdUser : string,
   payment:CollectionPaymentTypes

){
   this.buyerId = buyerId
   this.scrollDate = scrollDate
   this.createdUser = createdUser
this.scrollNo=scrollNo
this.invAmt =  invAmt
this.invNum = invNum
this.recievedAmt = recievedAmt
this.soId = soId
this.recievedDate =recievedDate
this.remarks =remarks
this.payment = payment

}
}